'use strict';
import {module} from '../app';

module.controller('OtherStudyDetailsCtrl', [
  '$scope', '$stateParams', 'otherStudyDetailsViewModel', '$rootScope', 
  function ($scope, $stateParams, viewModel, $rootScope) {
    let worklistId = $stateParams.worklistId;
    let ssn = $stateParams.ssn;
    let returnStateParams = $stateParams.returnStateParams;
    let studyId = $stateParams.studyId;
    $scope.vm = new viewModel(worklistId, ssn, returnStateParams, studyId);
    $scope.vm.isOnline = () => $rootScope.isOnline();
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/otherStudyDetails.js